import { Tooltip } from '@material-ui/core';
import { StyledIsChecked } from './InsightItem.style';
import Checkbox from 'components/base/Checkbox';

const ReadCheckbox = ({ toggleCheck, isChecked }) => {
  return (
    <Tooltip title={`Mark as ${isChecked ? 'unread' : 'read'}`} placement='top'>
      <StyledIsChecked
        onClick={e => {
          e.stopPropagation();
          toggleCheck();
        }}
      >
        <Checkbox checked={isChecked} />
      </StyledIsChecked>
    </Tooltip>
  );
};

export default ReadCheckbox;
